"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_TYPE = void 0;
var LOCATION_TYPE;
(function (LOCATION_TYPE) {
    LOCATION_TYPE["Point"] = "Point";
})(LOCATION_TYPE || (exports.LOCATION_TYPE = LOCATION_TYPE = {}));
